var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHifriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 276,
    viewBox: "0 0 199 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.975 253.449C57.975 253.449 54.4453 268.21 57.6541 268.851C60.8629 269.493 76.586 269.286 80.4366 269.928C84.2871 270.57 92.3091 269.493 92.3091 266.605C92.3091 263.717 83.9663 261.792 83.9663 261.792C83.9663 261.792 72.0937 255.375 71.7728 255.054C71.4519 254.733 57.975 253.449 57.975 253.449Z",
    fill: "#2F2E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7552 148.053C61.7552 148.053 62.9061 161.097 62.9061 162.248C62.9061 163.399 56.0004 224.015 57.535 236.292C59.0696 248.569 57.393 252.49 57.393 254.792C57.393 257.093 69.8118 256.242 69.8118 256.242L83.2395 171.455L76.3338 146.135L61.7552 148.053Z",
    fill: "#2F2E41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4671 256.681C62.4671 256.681 59.2584 268.233 62.4671 268.875C65.6759 269.517 81.3991 268.14 85.2496 268.782C89.1002 269.423 97.1222 269.517 97.1222 266.629C97.1222 263.741 88.7793 261.816 88.7793 261.816C88.7793 261.816 76.9068 255.398 76.5859 255.077C76.265 254.756 62.4671 256.681 62.4671 256.681Z",
    fill: "#2F2E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.945 50.4108C193.026 54.0154 191.78 58.6673 188.175 60.7484L172.064 70.0504C168.459 72.1315 163.807 70.885 161.726 67.2804L158.352 61.4366C156.271 57.832 157.518 53.1801 161.122 51.099L177.234 41.797C180.838 39.7159 185.49 40.9624 187.571 44.567L190.945 50.4108Z",
    fill: "#DCC225"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.149 60.6547C169.482 64.6962 168.589 69.5812 165.148 71.5677L107.092 105.086C103.651 107.073 98.9739 105.404 96.6405 101.363L96.2937 100.762C93.9603 96.7203 94.8537 91.8352 98.2945 89.8487L156.35 56.3301C159.791 54.3436 164.468 56.0124 166.802 60.0539L167.149 60.6547Z",
    fill: "#8B5E3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.654 97.2413C105.388 100.245 105.082 103.626 103.007 104.824L67.9984 125.036C65.9231 126.234 62.8426 124.809 61.1083 121.805L60.8561 121.368C59.1218 118.364 59.4274 114.983 61.5028 113.785L96.5111 93.5732C98.5865 92.3749 101.667 93.8005 103.401 96.8044L103.654 97.2413Z",
    fill: "#DCC225"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.364 43.4955C182.711 44.0962 182.667 44.777 182.23 45.0292L168.413 53.0068C167.976 53.2591 167.364 52.9567 167.017 52.356C166.671 51.7552 166.714 51.0745 167.151 50.8222L180.969 42.8446C181.406 42.5924 182.017 42.8947 182.364 43.4955Z",
    fill: "#F1F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M169.466 71.3764L191.162 58.9298L191.716 53.7L180.884 60.7999L165.887 68.8795",
    fill: "#DAA520"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.264 101.965L168.105 70.1757L171.105 61.9789L141.458 79.182L100.946 100.368",
    fill: "#DAA520"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.228 98.351L140.405 84.6804L140.885 88.6491L119.414 100.826L116.228 98.351Z",
    fill: "#DAA520"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 125.68,
    y: 97.1367,
    width: 10.4352,
    height: 5.35153,
    transform: "rotate(-29.1982 125.68 97.1367)",
    fill: "#DAA520"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.888 103.789L134.329 111.352L97.4534 269.108L94.5977 265.997L125.888 103.789Z",
    fill: "#8B5E3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.028 104.074L135.587 111.637L172.463 269.393L175.318 266.282L144.028 104.074Z",
    fill: "#8B5E3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.543 111.168H139.372L136.429 267.567H133.906L130.543 111.168Z",
    fill: "#8B5E3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.775,
    cy: 103.85,
    r: 9.32999,
    fill: "#DAA520"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2993 132.709C58.2993 132.709 53.6955 143.835 59.0666 149.589C64.4377 155.344 70.576 166.854 70.576 167.621C70.576 168.388 59.8339 244.734 61.3685 249.722C62.9031 254.709 62.5194 257.778 62.1358 258.546C61.7522 259.313 65.9723 263.533 70.576 263.533C75.1798 263.533 82.0855 260.08 82.8527 257.011C83.62 253.942 81.7018 227.47 82.0855 222.483C82.4691 217.495 97.815 137.696 95.8968 135.778C93.9786 133.86 58.2993 132.709 58.2993 132.709Z",
    fill: "#2F2E41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4581 44.4709C94.6621 44.4709 100.502 38.6309 100.502 31.4269C100.502 24.2228 94.6621 18.3828 87.4581 18.3828C80.2541 18.3828 74.4141 24.2228 74.4141 31.4269C74.4141 38.6309 80.2541 44.4709 87.4581 44.4709Z",
    fill: "#FFB9B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4023 37.9477C79.4023 37.9477 82.0879 52.1427 80.1696 53.6773C78.2514 55.2119 94.7483 57.5137 94.7483 57.5137C94.7483 57.5137 96.6665 38.715 97.0502 36.7967C97.4338 34.8785 79.4023 37.9477 79.4023 37.9477Z",
    fill: "#FFB9B9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0486 56.3628C97.0486 56.3628 99.5233 42.8451 80.7246 46.6816C80.7246 46.6816 63.5606 60.7552 64.3279 73.7992C70.0016 110.852 58.3002 124.652 59.0675 127.338C59.0675 127.338 54.4637 133.476 56.7656 134.627C59.0675 135.778 100.501 142.684 101.652 134.627C102.803 126.57 100.391 98.2396 103.11 85.9421C105.829 73.6445 102.036 66.3377 99.7342 62.5012C97.4323 58.6648 97.0486 56.3628 97.0486 56.3628Z",
    fill: "#DC9BA3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.288 23.3153C133.288 23.3153 143.437 3.10807 136.305 1.60212C129.172 0.0961787 124.871 22.3223 124.871 22.3223L133.288 23.3153Z",
    fill: "#FFB9B9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3532 88.4743C74.3532 88.4743 84.0746 97.2029 96.5348 83.4766C108.995 69.7502 119.563 55.9317 119.795 55.6428C120.026 55.3539 137.8 24.5513 133.906 21.4348C130.012 18.3183 126.554 16.4988 124.499 17.2242C122.445 17.9496 109.091 41.3881 109.091 41.3881C109.091 41.3881 93.0147 64.5439 85.069 69.56C77.1232 74.576 69.6554 83.2924 74.3532 88.4743Z",
    fill: "#DC9BA3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.7309 79.401L127.299 49.762L135.185 19.7244L123.459 47.4959L98.3368 79.8934",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.903 26.1478C100.894 24.8821 100.72 23.623 100.385 22.4033C98.1502 14.0771 89.9017 9.0798 81.6242 10.3339C80.0144 9.86841 78.3477 9.63309 76.6731 9.63477C72.4127 9.63479 68.2928 11.171 65.0574 13.9661C61.8219 16.7612 59.6841 20.6309 59.0301 24.8763L52.3438 68.2844H88.481L94.316 30.4039C94.5326 28.9961 94.5836 27.5676 94.4679 26.1478H100.903Z",
    fill: "#2F2E41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.1634 64.328L118.608 25.9967L104.925 48.6717L89.1634 64.328Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.728 270.089H0V268.828H198.021L197.728 270.089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHifriend);
export default __webpack_public_path__ + "static/media/hifriend.851fa04fdb4e1fd36433a7212ab316dc.svg";
export { ForwardRef as ReactComponent };